import isType from './is-type';
export default (function (str) {
  return isType(str, 'String');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/is-string.js
// module id = 8
// module chunks = 0